import { AlignmentType, Paragraph, TextRun } from "docx";

export const auditActivities = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 400 },

    children: [
        new TextRun({
            text: "Audit Activities",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const auditActivities1 = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 200, after: 300 },

    children: [
        new TextRun({
            text: "The following tests are conducted as part of the Security Audit:",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})

export const auditPoint1 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Application Fingerprinting",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint2 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Passive and Active testing",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint3 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "OWASP top 10 2025, NIST frameworks, OSSTMM3, SANS Top 25",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint4 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Vulnerability Identification and Analysis",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint5 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Exploitation of Vulnerabilities",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint6 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "SQL Injection",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint7 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Password attacks",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})


export const auditPoint8 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "HTTP methods",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint9 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Access Control Test",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const timelines = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 400 },

    children: [
        new TextRun({
            text: "Timelines",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})



export function timeline1(startDateString, endDateString) {
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        else {
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // Formatting start date
    const formattedStartDate = `${startDate.getDate()}`;
    const startOrdinalSuffix = getOrdinalSuffix(startDate.getDate());
    const startMonth = monthNames[startDate.getMonth()];
    const startYear = startDate.getFullYear();

    // Formatting end date
    const formattedEndDate = `${endDate.getDate()}`;
    const endOrdinalSuffix = getOrdinalSuffix(endDate.getDate());
    const endMonth = monthNames[endDate.getMonth()];
    const endYear = endDate.getFullYear();

    return new Paragraph({
        indent: { left: 600 },
        spacing: { line: 276 },
        bullet: { level: 0 },
        children: [
            new TextRun({
                text: "The Stage 1 Security Audit was executed from ",
                size: 24,
                font: "Arial",
                bullet: { level: 0 },
                color: '000000',
                italics: false,
                bold: false,
            }),
            // Start date part
            new TextRun({
                text: formattedStartDate,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: startOrdinalSuffix,
                superScript: true,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: ' ' + startMonth + ' ' + startYear + ' to ',
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            // End date part
            new TextRun({
                text: formattedEndDate,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: endOrdinalSuffix,
                superScript: true,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: ' ' + endMonth + ' ' + endYear,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            })
        ]
    });
}

